export function getCallButtonText(isLeadFactory: boolean) {
  if (isLeadFactory) {
    return 'Показать контакты';
  }

  return 'Контакты застройщика';
}
